import { RootState } from '../../../root-store/root.state';
import { createSelector } from '@ngrx/store';

export const selectSeButtonsToolbarFeature = (state: RootState) => state.buttonsToolbar;

export const selectSeButtonsToolbarButtons = createSelector(selectSeButtonsToolbarFeature, (state) => state.buttons);

// Selezione dello stato corrente
export const selectSeButtonsToolbarLeftSlider = createSelector(
    selectSeButtonsToolbarFeature,
    (state) => state.leftSlider,
);

// Selezione dello stato corrente
export const selectSeButtonsToolbarRightSlider = createSelector(
    selectSeButtonsToolbarFeature,
    (state) => state.rightSlider,
);

// Selezione dello stato corrente
export const selectSeButtonsTimeline = createSelector(
    selectSeButtonsToolbarFeature,
    (state) => state.timeline,
);
